'use client';

import React from 'react';
import get from 'lodash/get';
import { checkType } from '@/common/ultils';
import Image from 'next/image';
const ActivityBanner = ({ bannerMiddles, index = 0, deviceType }) => {
  const dataBanner = get(bannerMiddles, `results[${index}]`);

  if (!dataBanner) {
    return null;
  }

  const fileUrl = checkType(deviceType, dataBanner, 0, 'fileUrl', 'sharpMedias');
  return (
    <a href={`${dataBanner.linkTo}`} target="_blank" rel="noopener noreferrer" className="bg-gray-100 flex items-center justify-center text-gray-600">
      {/* <img src={fileUrl} alt={dataBanner.name} className="w-full h-full object-cover" /> */}
      <Image src={fileUrl} alt={dataBanner.name} fill className="w-full h-full object-cover position-initial" />
    </a>
  );
};

export default ActivityBanner;

